import type { RichDocument } from '../types';
import BlockRenderer from './blocks/BlockRenderer';

interface Props {
  doc: RichDocument;
}

export default function RichDocumentRenderer({ doc }: Props) {
  return (
    <article className="rich-doc">
      <header className="rich-doc-header">
        <h2 className="rich-doc-title">{doc.title}</h2>
        {doc.subtitle && <p className="rich-doc-subtitle">{doc.subtitle}</p>}
        {doc.metadata && doc.metadata.length > 0 && (
          <dl className="rich-doc-meta">
            {doc.metadata.map((m) => (
              <div key={m.label}>
                <dt>{m.label}</dt>
                <dd>{m.value}</dd>
              </div>
            ))}
          </dl>
        )}
      </header>

      {doc.sections.map((section) => (
        <section key={section.id} id={section.id} className="rich-doc-section">
          <h3 className="rich-doc-section-title">{section.title}</h3>
          {section.blocks.map((block, i) => (
            <BlockRenderer key={i} block={block} />
          ))}
        </section>
      ))}
    </article>
  );
}
